<div
  class="zag-card"
  [class.clickable]="clickable()"
  [attr.tabindex]="clickable() ? 0 : -1"
  [attr.role]="clickable() ? 'button' : null"
  (click)="onClick()"
  (keydown.enter)="onKeyActivate($any($event))"
  (keydown.space)="onKeyActivate($any($event))"
>
  <ng-content select="zag-card-title"></ng-content>
  <ng-content select="zag-card-body"></ng-content>
  <ng-content select="zag-card-footer"></ng-content>
</div>
